module.exports = __webpack_public_path__ + "img/icon_gongneng1.a721ebf2.svg";